import { Component, OnInit, ViewChild } from '@angular/core';
import { TeamFormComponent } from 'app/components/team-form/team-form.component';
import { Entity } from 'app/pages/product/product.model';
import { SystemService } from 'app/services/system.service';
import {EntityListComponent} from '../../../components/entity-list/entity-list.component';
import {User} from '../../../components/user-form/user.model';
import {Team} from '../../../components/team-form/team.model';

@Component({
  selector: 'app-team-page',
  templateUrl: './team-page.component.html',
  styleUrls: ['./team-page.component.scss']
})
export class TeamPageComponent implements OnInit {

    teams: Entity[];
    team: any;

    @ViewChild('teamForm')
    teamForm: TeamFormComponent;

    @ViewChild('entityList')
    entityList: EntityListComponent;

    constructor(public _systemService: SystemService) {
        
    }

    selected(entity): void{
        this.team = entity;
        this.teamForm.selected(entity);
    }

    ngOnInit(): void {
        this.teams = this._systemService.teams;
    }

    entityChanged(team: any){
        const activityIndex = this.teams.indexOf(this.team);
        this.teams.splice(activityIndex, 1);
        this.teams.push(team);
        this.teams.sort((a, b) => a.name > b.name ? 1 : -1);
    }

    newTeam(): void{
        this.team = new Team();
        this.entityList.deselectAll();
        this.selected(this.team);
    }

}
